import { render, staticRenderFns } from "./Treatment_Therapy_Form.vue?vue&type=template&id=79689dca&scoped=true&"
import script from "./Treatment_Therapy_Form.vue?vue&type=script&lang=js&"
export * from "./Treatment_Therapy_Form.vue?vue&type=script&lang=js&"
import style0 from "./Treatment_Therapy_Form.vue?vue&type=style&index=0&id=79689dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79689dca",
  null
  
)

export default component.exports